<div class="col-12 mb-3">
  <div class="table_responsive">
    <table mat-table [dataSource]="products">
      <caption></caption>
      <!-- Sl No Column -->
      <ng-container *ngFor="let name of displayedColumns" matColumnDef="{{ name }}">
        <th mat-header-cell *matHeaderCellDef>{{ name.replaceAll('_', ' ') | uppercase }}</th>
        <td mat-cell *matCellDef="let element; let i = index"><p-skeleton></p-skeleton></td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>
</div>
